var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowBarUp({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.12467 10.6667V5.91667H0.958008L6.49967 0.375L12.0413 5.91667H8.87467V10.6667H4.12467ZM0.958008 13.8333V12.25H12.0413V13.8333H0.958008Z",
    fill: "#0D6EFD"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBarUp);
export default __webpack_public_path__ + "static/media/ArrowBarUp.2f35f798.svg";
export { ForwardRef as ReactComponent };